module.exports = __webpack_public_path__ + "images/help/icon-twr58-b03ec1d94123477bc7fe11c2268965b1.png";